import React, { useState } from "react";
import NetaqInput from "./NetaqInput";
import ActionButton from "./ActionButton";
import { useDispatch, useSelector } from 'react-redux';
import { resetFilter } from "../Redux/Auctions/AuctionsSlice";
import { fetchAuctions } from '../Redux/Auctions/AuctionActions';
import { useTranslate } from "./TranslationText";
import SubmitBtn from "./SubmitBtn";
import NewActionButton from "./ActionButtons/NewActionButton";
import { filterButtonsContainer, filterCard, filterHeader, filterResetBtn, filterSubmitBtn } from "../common/cssclasses";

const AuctionFilter = ({ onSubmit }) => {
  const [checker, setChecker] = useState(true);
  const accessToken = localStorage.getItem("accessTokenforEAHS");
  const { translate } = useTranslate();
  const currentLanguage = localStorage.getItem('eahsLang');


  const [filterState, setFilterState] = useState({
    // Initial filter values
    auctionName: "",
    auctionType: "None",
    auctionStartDateFrom: "",
    auctionStartDateTo: "",
    skip: 0,
    take: 6,
    numberOfHorsesFrom: 0,
    numberOfHorsesTo: 0,
    dateRange: "LiveAndHybrid",
    enrolledAuction: false,
  });

  const dispatch = useDispatch();
  const [auctionStartFrom, setAuctionStartFrom] = useState(null);
  const [auctionStartTo, setAuctionStartTo] = useState(null);
  const handleChange = (event, input) => {
    if (!!input && input === "auctionStartDateFrom") {
      setAuctionStartFrom(event)

      setFilterState({
        ...filterState,
        auctionStartDateFrom: event.toDate(),
      });

      window.auctionFilter = {
        auctionStartFrom: event
      }
      console.debug('auctionFilter::handleChange::: %o', event);
      return;
    }
    if (!!input && input === "auctionStartDateTo") {
      setAuctionStartTo(event)
      setFilterState({
        ...filterState,
        auctionStartDateTo: event.$d.toISOString(),
      });
      return;
    }
    const value = event.target.type == 'checkbox' ? event.target.checked : event.target.value
    setFilterState({
      ...filterState,
      [event.target.name]: value,

    });


  };

  const handleSubmit = (event) => {
    window.scrollTo(0, 0);
    event.preventDefault();
    onSubmit(filterState); // Pass filter state to auctionPage
    // dispatch(resetFilter());
    // dispatch(fetchAuctions(filterState));
  };
  const handleReset = (event) => {
    setAuctionStartFrom(null);
    setAuctionStartTo(null);
    setFilterState({
      auctionName: "",
      auctionType: "None",
      auctionStartDateFrom: "",
      auctionStartDateTo: "",
      skip: 0,
      take: 0,
      numberOfHorsesFrom: 0,
      numberOfHorsesTo: 0,
      dateRange: "LiveAndHybrid",
      enrolledAuction: false,
    });
  };



  return (
    <form
      className={filterCard}
      onSubmit={handleSubmit}
      onReset={handleReset}
    >
      <h2 className={filterHeader}>{translate('web.advancedSearch', 'Advanced Search')}</h2>
      <div className="mb-form-group">
        <NetaqInput
          name={'auctionName'}
          label={translate("web.auctionName", "auction Name")}
          key={"search"}
          placeholder={translate("web.auctionName", "Auction Name")}
          type={"text"}
          onChange={handleChange}
        />
      </div>
      <div className="mb-form-group">

        {accessToken != null && accessToken !== "" && (
          <NetaqInput
            name={"enrolledAuction"}
            key={"enrolledAuction"}
            type={"checkbox"}
            checked={filterState.enrolledAuction}
            label={translate('web.enrolledAuctionWithQuestionMark', "Enrolled Auction?")}
            onChange={handleChange}
          />
        )}
      </div>
      <div className="mb-form-group">
        <label>
          {translate('web.auctionStage', 'Auction Stage')}
        </label>
        <div className="AuctionFilterRadioContainer">
          <NetaqInput
            name={"dateRange"}
            key={"Running"}
            type={"radio"}
            value={"LiveAndHybrid"}
            label={translate("web.running", "Running")}
            onChange={handleChange}
            checked={checker}
          />
          <NetaqInput
            name={"dateRange"}
            key={"Upcoming"}
            type={"radio"}
            value={"Upcoming"}
            label={translate("web.upcoming", "Upcoming")}
            onChange={handleChange}
          />

          <NetaqInput
            name={"dateRange"}
            key={"Past"}
            type={"radio"}
            value={"Past"}
            label={translate("web.past", "Past")}
            onChange={handleChange}
          />
        </div>
      </div>

      <div className="mb-form-group">
        <div className="row rtl">
          <div className="col-6">
            <NetaqInput
              name={"numberOfHorsesFrom"}
              key={"numberOfHoursesfrom"}
              type={"number"}
              value={1}
              label={<>
                {translate("web.numberOfHorses", "Number of horses")} {translate("web.from", "From")}
              </>
              }
              onChange={handleChange}
            />
          </div>
          <div className="col-6">
            <NetaqInput
              name={"numberOfHorsesTo"}
              key={"numberOfHoursesto"}
              type={"number"}
              value={50}
              label={<>
                {translate("web.numberOfHorses", "Number of horses")} {translate("web.to", "To")}
              </>
              }
              onChange={handleChange}
              minValue={filterState.numberOfHorsesFrom}
            />
          </div>
        </div>
      </div>
      <div className="mb-form-group-last">
        <div className="row">
          <div className="col-6">
            <NetaqInput
              name={"auctionStartDateFrom"}
              key={"auction-starting-date"}
              type={"date"}
              label={<>
                {translate("web.date", "Date")} {translate("web.from", "From")}
              </>
              }
              onChange={handleChange}
              value={auctionStartFrom}
            />
          </div>
          <div className="col-6">
            <NetaqInput
              name={"auctionStartDateTo"}
              key={"auction-end-date"}
              type={"date"}
              label={<>
                {translate("web.date", "Date")} {translate("web.to", "To")}
              </>
              }
              onChange={handleChange}
              value={auctionStartTo}
              minDate={auctionStartFrom}
            />
          </div>
        </div>
      </div>
      <div className={filterButtonsContainer}>
        <div className={filterResetBtn}>
          <NewActionButton
            key={"reset"}
            isButton
            classNames="btn-outline-secondary"

            type={"reset"}
            text={translate('web.reset', 'Reset')}
          />
        </div>
        <div className={filterSubmitBtn}>
          <NewActionButton
            isButton
            classNames="btn-danger"
            text={translate("web.search", "Search")}
            key={"apply"}
            type={"submit"}
          />
        </div>
      </div>
    </form>
  );
};

export default AuctionFilter;
